import { useIntroduction } from "@components/organisms/blogs-tamplates/components/introduction/index.server";
import { NavbarMenu } from "@models/types/menu.interface";

export function NavbarCard(item: NavbarMenu) {
  const { operations } = useIntroduction();
  return (
    <div className="flex flex-col w-[250px]">
      <figure className="flex h-[200px] flex-shrink-0 shadow-[0px_3px_6px_#00000029] mb-4">
        <img className="object-cover w-full" src={item.image} />
      </figure>
      {item.text && (
        <p className="font-chivo-regular text-[10px] text-custom-gray">
          {operations.dateConverter(item.text)}
        </p>
      )}
      <h3 className="text-dark-gray text-[15px] font-chivo-bold">
        {item.title}
      </h3>
    </div>
  );
}
